import {InternSet} from "internmap";

export default function difference(values, ...others) {
  values = new InternSet(values);
  for (const other of others) {
    for (const value of other) {
      values.delete(value);
    }
  }
  return values;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/difference.js
// module id = 410
// module chunks = 0